import { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { splitGamesIntoUnits } from './grid-utils';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { GridsContainer, Grid, CardContainer } from './grid.styles';

const cardsMap = {
	1: 'small',
	2: 'small',
	3: 'small',
	4: 'small',
	5: 'small',
	6: 'small',
	7: 'small',
	8: 'small',
	9: 'small'
} as const;

const cardPositions = {
	1: `
		grid-column: 1;
		grid-row: 1;
	`,
	2: `
		grid-column: 2;
		grid-row: 1;
	`,
	3: `
		grid-column: 3;
		grid-row: 1;
	`,
	4: `
		grid-column: 1;
		grid-row: 2;
	`,
	5: `
		grid-column: 2;
		grid-row: 2;
	`,
	6: `
		grid-column: 3;
		grid-row: 2;
	`,
	7: `
		grid-column: 1;
		grid-row: 3;
	`,
	8: `
		grid-column: 2;
		grid-row: 3;
	`,
	9: `
		grid-column: 3;
		grid-row: 3;
	`
};

type GridType5Props = {
	allowIncompleteUnits?: boolean;
};

const GridType5 = <T extends ReactElement<unknown>[]>({
	GameCards,
	allowIncompleteUnits = false
}: { GameCards: T } & GridType5Props) => {
	const isSmaller = useSelector(isSmallerSelector);

	const itemsPerUnit = 9;

	const units = useMemo(
		() => splitGamesIntoUnits(GameCards, itemsPerUnit, allowIncompleteUnits),
		[GameCards, itemsPerUnit, allowIncompleteUnits]
	);

	const cardSizes = useMemo(
		() => ({
			small: {
				width: isSmaller ? '104px' : '162px',
				height: isSmaller ? '104px' : '162px'
			}
		}),
		[isSmaller]
	);

	const gridSizes = useMemo(
		() => ({
			width: isSmaller ? '336px' : '510px',
			height: isSmaller ? '336px' : '510px'
		}),
		[isSmaller]
	);

	return (
		<GridsContainer>
			{units.map((cards, unitIndex) => (
				<Grid
					// eslint-disable-next-line react/no-array-index-key
					key={`unit-${unitIndex}`}
					width={gridSizes.width}
					height={gridSizes.height}
				>
					{cards.map((card, cardIndex) => (
						<CardContainer
							key={card.key}
							size={cardSizes[cardsMap[(cardIndex + 1) as keyof typeof cardsMap]]}
							position={cardPositions[(cardIndex + 1) as keyof typeof cardPositions]}
						>
							{card}
						</CardContainer>
					))}
				</Grid>
			))}
		</GridsContainer>
	);
};

export default GridType5;
